class DynamicSearchPlaceholder {
  constructor(inputSelector, placeholders) {
    this.input = null;
    this.placeholders = placeholders;
    this.currentIndex = 0;
    this.isTyping = false;
    this.timeoutId = null;
    this.inputSelector = inputSelector;
    this.originalPlaceholder = '';

    this.observeSidebar();
  }

  observeSidebar() {
    const sidebar = document.querySelector('#SearchSidebar');
    if (!sidebar) return;

    const setupInput = () => {
      this.input = document.querySelector(this.inputSelector);
      if (this.input && !this.isTyping) {
        this.originalPlaceholder = this.input.placeholder;
        this.init();
      }
    };

    if (sidebar.classList.contains('is-opened')) {
      setTimeout(setupInput, 100);
    }

    const observer = new MutationObserver(() => {
      if (sidebar.classList.contains('is-opened')) {
        setTimeout(setupInput, 100);
      } else {
        this.stopAnimation();
      }
    });

    observer.observe(sidebar, { attributes: true, attributeFilter: ['class'] });
  }

  init() {
    if (!this.input) return;

    this.input.addEventListener('focus', () => {
      this.input.placeholder = this.originalPlaceholder;
    });

    this.input.addEventListener('blur', () => {
      if (!this.input.value) {
        this.startAnimation();
      }
    });
  }

  startAnimation() {
    if (!this.input) return;
    if (this.isTyping) return;
    this.isTyping = true;
    this.animatePlaceholder();
  }

  stopAnimation() {
    this.isTyping = false;
    if (this.timeoutId) clearTimeout(this.timeoutId);
  }

  async animatePlaceholder() {
    if (!this.isTyping || !this.input) return;

    const text = this.placeholders[this.currentIndex];

    await this.typeText(text);
    await this.wait(2000); // po napisaniu całego słowa
    await this.deleteText(text);

    this.currentIndex = (this.currentIndex + 1) % this.placeholders.length;

    this.timeoutId = setTimeout(() => this.animatePlaceholder(), 500); // przerwa przed kolejnym słowem
  }

  typeText(text) {
    return new Promise((resolve) => {
      let i = 0;
      const type = () => {
        if (i < text.length && this.isTyping && this.input) {
          this.input.placeholder = text.substring(0, i + 1);
          i++;
          setTimeout(type, 100); // naturalna prędkość pisania
        } else {
          resolve();
        }
      };
      type();
    });
  }

  deleteText(text) {
    return new Promise((resolve) => {
      let i = text.length;
      const deleteChar = () => {
        if (i > 0 && this.isTyping && this.input) {
          this.input.placeholder = text.substring(0, i - 1);
          i--;
          setTimeout(deleteChar, 70); // naturalna prędkość kasowania
        } else {
          resolve();
        }
      };
      deleteChar();
    });
  }

  wait(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
}

function initPlaceholder() {
  const placeholders = [
    'Bluza medyczna Gaja',
    'Nude Mood',
    'Fartuszek Sophia',
    'Dark Chocolate',
    'Burgundy',
    'Spodnie medyczne Aura',
    'Bluzy medyczne',
    'Scrubsy'
  ];

  if (!window.dynamicPlaceholderInstance) {
    window.dynamicPlaceholderInstance = new DynamicSearchPlaceholder('[data-sidebar-search-input]', placeholders);
  }
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPlaceholder);
} else {
  initPlaceholder();
}
